export default {
  // 字符串 去掉头尾空格
  str_trim_left_and_right: str => str.replace(/(^\s*)|(\s*$)/g, ''),
  // 字符串 全局替换字符
  str_replace: (str, str1, str2) => str.replace(new RegExp(str1, 'g'), str2),
  // 字符串 首字母大写
  str_upper_case_first: str => str.charAt(0).toUpperCase() + str.slice(1),
  // 字符串 字母全大写
  str_upper_case_all: str =>
    str
      .split('')
      .map(x => x.toUpperCase())
      .join(''),
  // 字符串 字母全小写
  str_lower_case_all: str =>
    str
      .split('')
      .map(x => x.toLowerCase())
      .join(''),
  // 字符串 去重
  str_remove_repeat: str => [...new Set(str)].join(''),
  // 字符串 获取位长度 returns the byte length of an utf8 string
  str_byteLength: str => {
    let leng = str.length
    for (var i = str.length - 1; i >= 0; i--) {
      const code = str.charCodeAt(i)
      if (code > 0x7f && code <= 0x7ff) leng++
      else if (code > 0x7ff && code <= 0xffff) leng += 2
      if (code >= 0xdc00 && code <= 0xdfff) i--
    }
    return leng
  },
  // 字符串 获取随机字符串
  str_unique_string_create: () => {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
  },
}
